var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitorApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 9.99998C1.66675 6.85728 1.66675 5.28594 2.64306 4.30962C3.61937 3.33331 5.19071 3.33331 8.33341 3.33331H11.6667C14.8094 3.33331 16.3808 3.33331 17.3571 4.30962C18.3334 5.28594 18.3334 6.85728 18.3334 9.99998C18.3334 13.1426 18.3334 14.7141 17.3571 15.6903C16.3808 16.6666 14.8094 16.6666 11.6667 16.6666H8.33341C5.19071 16.6666 3.61937 16.6666 2.64306 15.6903C1.66675 14.7141 1.66675 13.1426 1.66675 9.99998Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16659 8.33335C9.16659 7.41288 8.42042 6.66669 7.49992 6.66669C6.57944 6.66669 5.83325 7.41288 5.83325 8.33335C5.83325 9.25385 6.57944 10 7.49992 10C8.42042 10 9.16659 9.25385 9.16659 8.33335Z",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 13.3333C10.8334 11.4924 9.341 10 7.50008 10C5.65913 10 4.16675 11.4924 4.16675 13.3333",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5H15.8333",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H15.8333",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorApproval);
export default __webpack_public_path__ + "static/media/visitor-approval.0901aa51bd47d17afb73229085f7a14c.svg";
export { ForwardRef as ReactComponent };